// Campus photo for /colleges/portland-state-university: CC BY-SA 4.0, by PortlandAppraisalBlog, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3ALet_Knowledge_Serve_the_City_skybridge%2C_Portland_State_University%2C_Portland%2C_Oregon%2C_2025.jpg), checked 2026-10-01 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/portland-state-university/; credited under the photo.
const photo = {
    "slug": "portland-state-university",
    "alt": "The Let Knowledge Serve the City skybridge over a street between Portland State University buildings in downtown Portland",
    "src": "/colleges/portland-state-university/campus-1600.webp",
    "srcSmall": "/colleges/portland-state-university/campus-800.webp",
    "srcMid": "/colleges/portland-state-university/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/portland-state-university/og.jpg",
    "title": "Let Knowledge Serve the City skybridge, Portland State University, Portland, Oregon, 2025",
    "author": "PortlandAppraisalBlog",
    "license": "CC BY-SA 4.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/4.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3ALet_Knowledge_Serve_the_City_skybridge%2C_Portland_State_University%2C_Portland%2C_Oregon%2C_2025.jpg",
    "read": "2026-10-01"
};

export default photo;
